import React from 'react';
import axios from 'axios';
import { Upload, FileText } from 'lucide-react';
import { formatDate } from '../../crmConstants';

const API = process.env.REACT_APP_BACKEND_URL;

export const DealDocsTab = ({ dealId, documents, onRefresh }) => {
  const uploadDocument = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post(`${API}/api/admin/deals/${dealId}/documents`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      onRefresh();
    } catch (err) {
      console.error('Failed to upload document:', err);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <label style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
        padding: '1.5rem', borderRadius: 8, border: '2px dashed #E5E7EB', cursor: 'pointer',
        color: '#6B7280', fontSize: '0.875rem',
      }}>
        <Upload size={18} />
        Click to upload a document
        <input type="file" onChange={uploadDocument} style={{ display: 'none' }} data-testid="deal-doc-upload-input" />
      </label>

      {documents.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '1rem' }}>No documents yet</p>
      ) : documents.map(doc => (
        <div key={doc.id} style={{
          padding: '0.75rem', borderRadius: 6, background: '#FAFBFC', border: '1px solid #E5E7EB',
          display: 'flex', alignItems: 'center', gap: '0.75rem',
        }}>
          <FileText size={20} style={{ color: 'var(--teal)' }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '0.813rem', fontWeight: 500, color: 'var(--navy)' }}>{doc.filename}</div>
            <div style={{ fontSize: '0.7rem', color: '#9CA3AF' }}>
              {(doc.size / 1024).toFixed(1)} KB • {formatDate(doc.uploaded_at, true)} • {doc.uploaded_by_name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
